import { uniq } from 'lodash-es';
import { ApiQuery } from '../../core/api/entities/api-query.entity';
import { DottedKey } from '../../core/field-definitions/entities/field-definition.entity';
import { FacetProfile } from '../../core/profiles/entities/profile.entity';
import { FacetRequest, FacetValueConstraint, FacetValueOptions } from '../entities/facet-request.entity';

export function createFacetRequest(
    query: ApiQuery,
    facetProfiles: FacetProfile[],
    dialogDottedKey?: DottedKey,
    dialogSelection?: FacetValueConstraint,
    dialogConfig?: FacetValueOptions
): FacetRequest {
    const request: FacetRequest = {
        Search: {
            StructuredQuery: query.toApiStructuredQuery()
        }
    };

    if (dialogDottedKey) {
        request['Value'] = {
            ...(dialogConfig ? { Options: { [dialogDottedKey]: dialogConfig } } : {}),
            ...(dialogSelection ? { Constraints: { [dialogDottedKey]: dialogSelection } } : {})
        };
    }

    if (facetProfiles.length === 1) {
        request['Source'] = {
            ProfileId: facetProfiles[0].Id
        };
    } else {
        request['Source'] = {
            CustomFacets: uniq(facetProfiles.flatMap(profile => profile.Fields.map(field => field.DottedKey)))
        };
    }

    return request;
}
